import settings from './settings'
import { addLocaleData } from 'react-intl'
import faLocaleData from 'react-intl/locale-data/fa'
import enLocaleData from 'react-intl/locale-data/en'
import { setupLogger } from './services/logger'
// import store from './stores/store'
const { formzCssLinkId, formCssUrl, hostedCssUrlPattern, isRTL, inDevMode } =
  settings

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // startChromeDevTools,
  // disableRightClick,
  // watchForAdminCommands
  // monitorPerformance,
  addCssLinkIfNotFound,
  createCssTag,
  addFarsiLocaleData,
  startLogService,
]

// export function startChromeDevTools(env) {
//   if (env === 'development') {
//     require('inferno-devtools')
//   }
// }

// const preventRightClick = event => {
//   event.preventDefault()
//   return false
// }

// export function disableRightClick(env) {
//   if (env === 'development') return
//   document.body.addEventListener('contextmenu', preventRightClick)
// }

// performance monitoring
// export function monitorPerformance(env) {
//   if (env !== 'development') return

const isCssTagPresent = () => {
  const re = new RegExp(hostedCssUrlPattern)
  const links = [...document.head.querySelectorAll('link')]

  const isPresent = links.some((link) => {
    return re.test(link.href) || link.href === formCssUrl
  })

  return isPresent
}

export function addCssLinkIfNotFound(env) {
  if (env !== 'development') {
    if (!isCssTagPresent()) {
      // console.log('Adding css tag...')
      document.head.appendChild(createCssTag())
    }
  }
}

export function createCssTag() {
  const link = document.createElement('link')

  link.setAttribute('rel', 'stylesheet')
  link.setAttribute('id', formzCssLinkId)
  link.setAttribute('href', formCssUrl)

  return link
}

function addFarsiLocaleData() {
  // register farsi to react-intl
  if (isRTL()) {
    addLocaleData(faLocaleData)
  } else {
    addLocaleData(enLocaleData)
  }
}

// function watchForAdminCommands(env) {
//   const cheatCode = 'i d e a r u n a d m i n'

//   import('cheet.js').then(cheat => {
//     cheat(cheatCode, () => {
//       document.body.removeEventListener('contextmenu', preventRightClick)
//       alert('You now have access to the console')
//     })
//   })
// }

// function getUserInfo() {
//   return store.getState().auth
// }

function startLogService() {
  if (!inDevMode) {
    setupLogger()
  }
}
